import { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import { Link, useLocation } from "react-router-dom";
import { getNavLinks } from '../navLinks';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import ActiveUnitSelector from '../ActiveUnitSelector/ActiveUnitSelector';
import './SidebarDesktop.css';

const SidebarDesktop = ({ collapsed, onToggle }) => {
    const location = useLocation();
    const [tooltip, setTooltip] = useState({ visible: false, label: '', y: 0 });

    const user = JSON.parse(localStorage.getItem("user")) || {};
    const cooperative = JSON.parse(localStorage.getItem("units")) || [JSON.parse(localStorage.getItem("cooperative"))] || [];

    const navLinks = getNavLinks(user, cooperative);

    const handleMouseEnter = (e, label) => {
        if (!collapsed) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({ visible: true, label, y: rect.top + rect.height / 2 });
    };

    const handleMouseLeave = () => setTooltip({ visible: false, label: '', y: 0 });

    return (
        <div className="sidebar-scroll-container">
            <button
                className="sidebar-toggle-btn"
                onClick={onToggle}
                title={collapsed ? "Expandir menu" : "Recolher menu"}
            >
                {collapsed ? <HiChevronRight size={16} /> : <HiChevronLeft size={16} />}
            </button>
            <div className="px-2 mt-2">
                <ActiveUnitSelector dark compact={collapsed} />
            </div>
            <Nav className="flex-column">
                {navLinks.filter(link => link?.permission).map((link, idx) => (
                    <div
                        key={idx}
                        className="nav-lateral-wrapper"
                        onMouseEnter={e => handleMouseEnter(e, link.label)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <Link
                            to={link.path}
                            className={`nav-lateral mt-2 ${location.pathname === link.path ? 'active' : ''}`}
                        >
                            <div className={`icon-text${collapsed ? ' collapsed' : ''}`}>
                                <span className="menu-icon-wrap">{link.icon}</span>
                                {!collapsed && <span className="menu-text">{link.label}</span>}
                            </div>
                        </Link>
                    </div>
                ))}
            </Nav>

            {!collapsed && (
                <div className="sidebar-company-logo">
                    <img
                        src="/images/motomco_logo_reduzida_branca.png"
                        alt="Motomco"
                    />
                </div>
            )}

            {tooltip.visible && (
                <div
                    className="sidebar-tooltip"
                    style={{ top: tooltip.y }}
                >
                    {tooltip.label}
                </div>
            )}
        </div>
    );
};

export default SidebarDesktop;
